<cap-content-header>
  <cap-title>
    {{ "grundbuchmeldungen.ListTitel" | translate }}
  </cap-title>
  @if (grundbuchmeldungResponse) {
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons [listLoader]="listLoader">
        <button
          (click)="getZip()"
          [disabled]="!grundbuchmeldungResponse.hasPrintRight"
          [ngClass]="{ disabled: !grundbuchmeldungResponse.hasPrintRight }"
          class="btn btn-outline-primary btn-sm"
          type="button">
          {{ "MeldungenAlsZip" | translate }}
          @if (isDownloading) {
            <span style="font-size: 1rem">
              <i class="fas fa-spinner fa-pulse fa-fw spinner"></i>
            </span>
          }
        </button>
      </cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  }
</cap-content-header>

<div class="my-4">
  @if (listLoader) {
    <div>
      <cap-list-loader [listLoader]="listLoader">
        <div class="cap-list-loader-content">
          <table class="cap-table-search">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    </div>
  } @else {
    <cap-spinner-small></cap-spinner-small>
  }
</div>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('geschaeftsNummer')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Geschäftsstatus'" [sortModel]="tableSortModel.columns.get('geschaeftsstatus')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Abschlussdatum'" [sortModel]="tableSortModel.columns.get('abschlussdatum')"></cap-column-header>
    </th>
    <th>
      {{ "Beschreibung" | translate }}
    </th>
    <th>
      {{ "BetroffeneGemeinden" | translate }}
    </th>
    @if (showBearbeitungsstatus) {
      <th>
        <cap-column-header [columnName]="'Bearbeitungsstatus'" [sortModel]="tableSortModel.columns.get('bearbeitungsstatus')">
        </cap-column-header>
      </th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        <cap-kompakt-grundbuchgeschaeft [item]="item.grundbuchgeschaeft" container="body"></cap-kompakt-grundbuchgeschaeft>
      </td>
      <td>
        <cap-link [params]="[item.grundbuchgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG">
          {{ item.geschaeftsstatus | translate }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[item.grundbuchgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG">
          {{ item.abschlussDatum | datum }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[item.grundbuchgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG">
          @if (item.beschreibung) {
            <span>
              {{ item.beschreibung }}
            </span>
          } @else {
            {{ "GemaessGrundbuch" | translate }}
          }
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[item.grundbuchgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG">
          @for (gemeinde of item.betroffeneGemeinden; track gemeinde) {
            <span> {{ gemeinde.name | translateName }}<br /> </span>
          }
        </cap-link>
      </td>
      @if (showBearbeitungsstatus) {
        <td>
          <cap-link [params]="[item.grundbuchgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG">
            {{ item.bearbeitungsstatus | translate }}
          </cap-link>
        </td>
      }
    </tr>
  }
</ng-template>
